import React from 'react';
import * as Yup from 'yup';
import { Formik } from "formik";

const validationSchema = Yup.object({
  usuario: Yup.string(),
  estatus: Yup.number()
});


export default function FiltrosUsuarios(props) {
  const { Filter, TipoU,Cooperativas } = props;
  return (
    <Formik
      initialValues={{
        usuario: '',
        estatus: '',
        tipo_usuario: '',
        cooperativa:''
      }}
      validationSchema={validationSchema}
      enableReinitialize="true"
      onSubmit={(values, actions) => {
        Filter(values, actions);
        //alert("pass " + $("#usuario").val());
        //Search(values, actions);
      }}>
      {({
        values,
        errors,
        status,
        setFieldValue,
        handleBlur,
        handleChange,
        handleSubmit,
        resetForm
      }) => <form onSubmit={handleSubmit} autoComplete="off" >
          <div className='row'>
            <div className={TipoU==1?"col-sm-3 col-md-3 col-lg-3":"col-sm-3 col-md-3 col-lg-3"}>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Usuario:</label>
                <input type="text" name='usuario' className='form-control form-control-sm' value={values.usuario || ''} onChange={handleChange} />
                <span className="help-block">{errors.f_fin}</span>
              </div>
            </div>
            {TipoU == 1 && (
              <>
                <div className={TipoU==1?"col-sm-3 col-md-3 col-lg-3":"col-sm-3 col-md-3 col-lg-3"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Cooperativa:</label>
                    <select name="cooperativa" id="cooperativa" className='form-select form-select-sm' value={values.cooperativa || ''} onChange={handleChange}>
                      <option value="">Seleccione uno</option>
                      {Cooperativas && Cooperativas.map((elm,key)=>(
                        <option key={key} value={elm.id}>{elm.nombre}</option>
                      ))}
                    </select>
                    <span className="help-block">{errors.cooperativa}</span>
                  </div>
                </div>
                <div className={TipoU==1?"col-sm-2 col-md-2 col-lg-2":"col-sm-3 col-md-3 col-lg-3"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Tipo:</label>
                    <select name="tipo_usuario" id="tipo_usuario" className='form-select form-select-sm' value={values.tipo_usuario || ''} onChange={handleChange}>
                      <option value="">Seleccione uno</option>
                      <option value="2">Cooperativa</option>
                      <option value="3">Corredor</option>
                    </select>
                    <span className="help-block">{errors.tipo_usuario}</span>
                  </div>
                </div>
              </>
            )}
            <div className={TipoU==1?"col-sm-2 col-md-2 col-lg-2":"col-sm-3 col-md-3 col-lg-3"}>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Estatus:</label>
                <select name="estatus" id="estatus" className='form-select form-select-sm' value={values.estatus || ''} onChange={handleChange}>
                  <option value="">Seleccione uno</option>
                  <option value="1">Activo</option>
                  <option value="0">Inactivo</option>
                </select>
                <span className="help-block">{errors.estatus}</span>
              </div>
            </div>
            <div className={TipoU==1?"col-sm-2 col-md-2 col-lg-2":"col-sm-3 col-md-3 col-lg-3"}>
              <div className="form-group" style={{ paddingTop: '30px' }}>
                <button type='submit' className='btn btn-sm mt-30 text-white' style={{ background: "#E6453B" }}>Buscar</button>
              </div>
            </div>
          </div>
        </form>
      }
    </Formik>
  )
}
